<template>
    <div class="unavailability-reason">
        <xl-dialog :title="$t('design.orderDetail.unavailableReasonTitle')" v-model="visible" width="566px" destroy-on-close >
            <xl-form ref="formRef" :model="form" :rules="rules" label-position="top" show-message>
                <xl-form-item :label="$t('design.orderDetail.unavailableReason')" prop="reason">
                    <xl-select class="select-width" v-model="form.reason" :options="reasonList" size="large" multiple clearable collapse-tags collapse-tags-tooltip></xl-select>
                </xl-form-item>
                <xl-form-item :label="$t('design.remark')" prop="remark">
                    <xl-input v-model="form.remark" size="large" type="textarea" show-word-limit maxlength="100" rows="6" :placeholder="$t('design.inputRemark') || '请输入备注内容'"></xl-input>
                </xl-form-item>
            </xl-form>
            <template #footer>
                <div class="footer-button">
                    <xl-button @click="close">{{
                        $t("design.cancel") || "取消"
                        }}</xl-button>
                    <xl-button type="primary" @click="handleSubmit">{{
                        $t("design.submit") || "提交"
                        }}</xl-button>
                </div>
            </template>
        </xl-dialog>
    </div>
</template>

<script setup>
import {
    XlDialog,
    XlForm,
    XlFormItem,
    XlSelect,
    XlInput,
    XlButton,
    XlMessage
} from "@shining3d/ui-components";
import { ref, watch } from "vue";
import { cloneDeep } from "lodash";
import { useLang } from "@shining3d/common-module/utils/lang.js";
import router from "@/router";
import { orderDetail } from '../../../api/orderDetail/index.js';
import { VueCookieNext } from 'vue-cookie-next';
import Bus from '../../../utils/bus.js';

const props = defineProps({
    orderID: String,
    platform: {
        type: String,
        default: 'dental'
    },
    detailInfo: Object
})

const Api = orderDetail[props.platform || 'dental'];
const emits = defineEmits(['changeApply', 'getDetail'])
const route = router.currentRoute.value;
const { $t } = useLang("@shining3d/xl-design-order");
const lang = ref(VueCookieNext.getCookie("lang"));
const visible = ref(false);
const show = () => {
    form.value = cloneDeep(initInfo);
    visible.value = true;
};
const formRef = ref();
const initInfo = {
    reason: [],
    remark: "",
};
const form = ref(cloneDeep(initInfo));
const rules = {
    reason: [
        {
            required: true,
            message: $t("rules.notEmpty") || "不能为空",
            trigger: "change",
        }
    ]
};
// 不可用原因列表
const reasonList = ref([]);

const getReasonList = ( productConfig, productType ) => {
    reasonList.value = [];
    Api.dentalxCloudListAiLabel({
        transferOrderID: props.platform === 'dental' ? '' : props.orderID || route?.params?.id,
        page: -1,
        productConfig: productConfig,
        productType: productType,
        lang: lang.value
    }).then((res) => {
        if( res && res.status === 'success' ){
            (res?.result?.result || []).forEach((item) => {
                // const list = item.langParam?.find((it) => it.lang === lang.value)
                item.langParam?.forEach((it) => {
                    if( it.lang === lang.value ){
                        reasonList.value.push({
                            label: it?.name,
                            value: item?.id
                        })
                    }
                })
            })
        }
    })
}
const close = () => {
    visible.value = false;
}
// 提交不可用原因
const handleSubmit = () => {
    let source = props.platform;
    if ( props.platform === 'designerService' ) {
        source = 'dentalxDesign';
    }

    formRef.value.validate((valid) => {
        if(valid){
            // emits('changeApply', 'unavailable')
            Api.dentalxSetOrderAiReason({
                orderID: props.orderID || route?.params?.id,
                reasonID: form.value.reason, 
                state: 'disable', 
                remark: form.value.remark,
                source
            }).then((res) => {
                if( res && res.status === 'success' ){
                    close();
                    if ( props.platform === 'designerService' ) {
                        emits( 'getDetail' );
                    } else {
                        router.push({name: 'designOrder'});
                        Bus.$emit( 'updateOrderList' );
                    }
                } else {
                    close();
	                XlMessage({ type: 'error', message: $t('design.orderDetail.submitError') || '提交失败' });
                }
            })
            
        }
    })
}

watch(() => props.detailInfo, val => {
    if( val?.productConfig && val?.productType ){
        getReasonList( val?.productConfig, val?.productType );
    }
}, {immediate: true, deep: true})

defineExpose({ show });
</script>
<style lang="scss" scoped>
.unavailability-reason{
    .select-width{
        width: 516px;
    }
    :deep(.el-form-item__label){
        font-family: 'Alibaba PuHuiTi 2.0';
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        text-align: left;
        color: #42526E;
    }
    :deep(.xl-dialog.el-dialog){
        min-width: 566px !important;
    }
}
</style>